export const UPDATE_INTRODUCTION_DATA:string = 'introduction/UPDATE_INTRODUCTION_DATA';